// phpcs:ignoreFile
/* eslint-disable */
const shipToBilling = true;
$(document).ready(function () {
  $(".btn-hide-panel").on("click", function () {
    if ($(this).text() == "Hide") $(this).text("Show");
    else $(this).text("Hide");
  });

  $(".product-row").last().css("border-bottom", "none");

  $(".chevron-swap a").on("click", function () {
    const elem = $(this).closest(".panel-heading").find(".glyphicon");
    if ($(elem).hasClass("glyphicon-chevron-up")) {
      $(".chevron-swap .glyphicon-chevron-up")
        .removeClass("glyphicon-chevron-up")
        .addClass("glyphicon-chevron-down");
      $(elem)
        .removeClass("glyphicon-chevron-up")
        .addClass("glyphicon-chevron-down");
    } else if ($(elem).hasClass("glyphicon-chevron-down")) {
      $(".chevron-swap .glyphicon-chevron-up")
        .removeClass("glyphicon-chevron-up")
        .addClass("glyphicon-chevron-down");
      $(elem)
        .removeClass("glyphicon-chevron-down")
        .addClass("glyphicon-chevron-up");
    }
  });

  $("a.accordian-toggle").on("click", function () {
    if ($(".glyphicon", this).hasClass("glyphicon-chevron-up")) {
      $(".glyphicon-chevron-up", this)
        .removeClass("glyphicon-chevron-up")
        .addClass("glyphicon-chevron-down");
    } else if ($(".glyphicon", this).hasClass("glyphicon-chevron-down")) {
      $(".glyphicon-chevron-down", this)
        .removeClass("glyphicon-chevron-down")
        .addClass("glyphicon-chevron-up");
    }
  });
  if (
    $("#page-account-order").length ||
    $("#page-card-change").length
  ) {
    $(".billing-address-fields").collapse({ toggle: false });
    if ($(".existing-address").length) {
      $('.billing-address-controls input[type="radio"]').on(
        "change click",
        function () {
          if ($(".billing-address-controls input.new-address").is(":checked")) {
            $(".billing-address-fields").collapse("show");
            $(".toggle-required").attr("required", "required");
          } else {
            $(".billing-address-fields").collapse("hide");
            $(".toggle-required").removeAttr("required");
          }
        }
      );
    }
  }

  const delay = 0;
  const offset = 150;

  document.addEventListener(
    "invalid",
    function (e) {
      $(e.target).addClass("invalid");
    },
    true
  );
  document.addEventListener(
    "change",
    function (e) {
      $(e.target).removeClass("invalid");
    },
    true
  );

  $(".look-up, .billing-address-fields, .shipping-address-fields").collapse({
    toggle: false,
  });

  $("#filter").keyup(function () {
    const rex = new RegExp($(this).val(), "i");
    $(".searchable tr.hideable").hide();
    $(".searchable tr.hideable")
      .filter(function () {
        return rex.test($(this).text());
      })
      .show();
  });
  $("#filterPanels").keyup(function () {
    const rex = new RegExp($(this).val(), "i");
    $(".panel-default.searchable, .subscription-item").hide();

    $(".panel-default.searchable, .subscription-item")
      .filter(function () {
        return rex.test($(".searchBy", this).text());
      })
      .show();
  });

  $("#filter_subs").on("keyup", function () {
    const str = $(this).val().toLowerCase();

    $(".subscription-item").each(function () {
      const panel = $(this);

      if (str.length) {
        if (
          $(".panel-heading", panel).text().toLowerCase().indexOf(str) < 0 &&
          panel.data("first-name").toLowerCase().indexOf(str) < 0 &&
          panel.data("last-name").toLowerCase().indexOf(str) < 0 &&
          panel.data("email").toLowerCase().indexOf(str) < 0
        ) {
          panel.hide();
        } else {
          panel.show();
        }
      } else {
        panel.show();
      }
    });
  });

  $("#filter_subs_var").on("keyup", function () {
    const str = $(this).val().toLowerCase();

    $(".subscription-item").each(function () {
      const panel = $(this);
      const parent = $(this).closest(".panel.searchable");

      if (str.length) {
        // Check parent first for customer info
        if (parent.find(".searchBy").text().toLowerCase().indexOf(str) < 0) {
          if (
            $(".panel-heading", panel).text().toLowerCase().indexOf(str) < 0 &&
            panel.data("first-name").toLowerCase().indexOf(str) < 0 &&
            panel.data("last-name").toLowerCase().indexOf(str) < 0 &&
            panel.data("email").toLowerCase().indexOf(str) < 0
          ) {
            panel.addClass("filtered");
            panel.hide();
          } else {
            panel.removeClass("filtered");
            panel.show();
          }
        } else {
          panel.removeClass("filtered");
          parent.show();
          panel.show();
        }
      } else {
        panel.removeClass("filtered");
        parent.show();
        panel.show();
      }
    });

    $(".panel.searchable").each(function () {
      let count = 0;

      $(this)
        .find(".subscription-item")
        .each(function () {
          if ($(this).hasClass("filtered")) count++;
        });

      if (count == $(this).find(".subscription-item").length) $(this).hide();
      else $(this).show();
    });
  });

  $("tr.linked").on("click", function () {
    if ($(this).data("href").length)
      window.document.location = $(this).data("href");
  });

  $('[data-toggle="tooltip"]').tooltip();
});
